import { render, staticRenderFns } from "./skiniver-detail.vue?vue&type=template&id=5731782c&scoped=true&"
import script from "./skiniver-detail.vue?vue&type=script&lang=js&"
export * from "./skiniver-detail.vue?vue&type=script&lang=js&"
import style0 from "./skiniver-detail.vue?vue&type=style&index=0&id=5731782c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5731782c",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CImage: require('@chakra-ui/vue').CImage, CFlex: require('@chakra-ui/vue').CFlex, CBox: require('@chakra-ui/vue').CBox, CModalCloseButton: require('@chakra-ui/vue').CModalCloseButton, CModalBody: require('@chakra-ui/vue').CModalBody, CModalContent: require('@chakra-ui/vue').CModalContent, CModalOverlay: require('@chakra-ui/vue').CModalOverlay, CModal: require('@chakra-ui/vue').CModal})
